import axios from "axios";
import { getAdminToken, getSessionId, getUserToken } from "@/store/session";
import router from "@/router";
import { ElMessage, ElLoading } from "element-plus";
import { saveAs } from 'file-saver'
import { SessionCache } from '@/utils/sessionCache.js'

// const router = useRouter();
axios.defaults.timeout = 120000;
axios.defaults.withCredentials = true;
// axios.defaults.headers.post["Content-Type"] = "application/json";
// HTTP拦截器
axios.interceptors.request.use(
  (config) => {
    if (config.url == "/api/pc/files/upload") {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    config.headers["Authorization"] = getUserToken();
    config.headers['time'] = SessionCache.get('time')
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    let data = response.data;
    if (data.code == 200) {
      return data;
    } else if (data.code == 401 || data.code == 403) {
      ElMessage.error(data.msg || "登录过期，请重新登录");
      localStorage.clear();
      if (window.location.href.includes("cabplink")) {
        window.open(
          "https://kscecs1.cabplink.com/account-login?redirect=http%3A%2F%2Fsgai1.cabplink.com%2Fhome%3Ftype%3D1  "
        );
      } else if (window.location.href.includes("kscecs")) {
        window.open(
          "https://www.kscecs.com/account-login?redirect=https%3A%2F%2Fsgai.kscecs.com%2Fhome%3Ftype%3D1"
        );
      } else {
        router.push("/chat");
      }
      return data
    } else if (data.code == 500) {
      ElMessage.error(data.msg || "系统错误请联系管理员");
      return data
    } else {
      return data

    }
  },
  (error) => {
    return Promise.reject(error);
  }
);




export function httpGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        if (response.data.data) {
          resolve(response.data);
        } else {
          resolve(response);
        }
        // resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function httpPost(url, data = {}, options = {}, params = {},) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, options, params)
      .then((response) => {
        if (response.data.data) {
          resolve(response.data);
        } else {
          resolve(response);
        }
      })
      .catch((err) => {
        // console.log(err);
        reject(err);
      });
  });
}
export function httpPostQuery(url, data = {}, options = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, options)
      .then((response) => {
        if (response.data.data) {
          resolve(response.data);
        } else {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function httpDelete(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        if (response.data.data) {
          resolve(response.data);
        } else {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function httpPut(url, data = {}, options = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, options)
      .then((response) => {
        if (response.data.data) {
          resolve(response.data);
        } else {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
let downloadLoadingInstance;
// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = ElLoading.service({
    text: "正在下载数据，请稍候",
    background: "rgba(0, 0, 0, 0.7)",
  });
  return axios
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params);
        },
      ],
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      responseType: "blob",
      ...config,
    })
    .then(async (data) => {
      const isBlob = blobValidate(data);
      if (isBlob) {
        const blob = new Blob([data]);
        saveAs(blob, filename);
      } else {
        const resText = await data.text();
        const rspObj = JSON.parse(resText);
        const errMsg =
          errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
        ElMessage.error(errMsg);
      }
      downloadLoadingInstance.close();
    })
    .catch((r) => {
      console.log(r);
      ElMessage.error("下载文件出现错误，请联系管理员！");
      downloadLoadingInstance.close();
    });
}

function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== "" &&
            typeof value[key] !== "undefined"
          ) {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}
// 验证是否为blob格式
function blobValidate(data) {
  return data.type !== "application/json";
}
export default axios 